import GraphqlBuilder, { graphqlOptions } from "utils/request/graphql/builder";
import _ from "lodash";
import { constantsActive } from 'utils/constants/constants'
import { createTranslationMutationParameters } from 'components/molecules/Form'
import MutationTimeslot from 'graphql/mutations/MutationTimeslot'
import MutateToTimeslot from 'utils/mutate/to-timeslot'

export default class MutateTimeslot {
	
	static log( value ) {
		console.prefix('MutateTimeslot', value );
	}
	
	static mutate = ( values, { callbackSuccess = null, callbackError = null, callbackStart = null, table = null, guid = null } = {} ) => {
		const timeslots = [];
		_.forEach( values, ( o, key ) => {
			if( _.startsWith( key, 'timeslot' ) ) {
				timeslots.push( o );
			}
		})
		
		const builder = new GraphqlBuilder({
			[ graphqlOptions.processVariables ]: false
		});
		
		const variables = {};
		if( table !== null && guid !== null ) {
			variables[ MutateToTimeslot.tableToGuid( table ) ] = guid;
		}
		
		_.forEach( timeslots, (timeslotInput, key) => {
			let translations = {};
			if( "translations" in timeslotInput && _.size( timeslotInput.translations ) > 0 ) {
				translations = createTranslationMutationParameters( timeslotInput.translations );
			}
			
			_.forEach( _.get( timeslotInput, 'timeslots', [] ), timeslot => {
				builder.addQuery( `mutation_timeslot_${ key }_${ timeslot.timeslot_day }`, MutationTimeslot, {
					// Timeslot specific
					guid: _.get( timeslot, 'guid', null ),
					timeslot_day: timeslot.timeslot_day,
					
					// Input
					kind: timeslotInput.kind,
					sub_kind: timeslotInput.sub_kind,
					timeslot_start: timeslotInput.timeslot_start,
					timeslot_end: timeslotInput.timeslot_end,
					capacity: _.get( timeslotInput, 'capacity', null ),
					translations: translations,
					
					active: constantsActive.YES,
					
					...variables,
				} );
			})
		});
		
		builder.setOnStart( callbackStart )
		builder.setOnSuccess( ( result ) => {
			this.onSuccess( result, callbackSuccess );
		});
		builder.setOnError( (result) => {
			this.onSuccess( result, callbackError );
		} );
		
		if( builder.queries.length > 0 ) {
			builder.execute();
			return;
		}
		
		this.onSuccess( {}, callbackSuccess );
	}
	
	/**
	 *
	 * @param result
	 * @param callback
	 */
	static onSuccess = ( result, callback ) => {
		const timeslots = [];
		_.forEach( result, o => {
			timeslots.push( o.timeslot );
		})
		
		if( _.isFunction( callback ) ) {
			callback( timeslots );
		}
	}
	
	/**
	 *
	 * @param result
	 * @param callback
	 */
	static onError = ( result, callback ) => {
		if( _.isFunction( callback ) ) {
			callback( result );
		}
	}
}
